import { Workflow } from './workflow';
import { UserProfile } from './user-profile';
import { Formulaire } from './formulaire';
import { ServiceTask } from './serviceTask';

export class TaskWorkflowByProfile {
         id: number | undefined;
         active: Boolean;
         taskKey: String;
         taskName: String;
         type:String;
         workflow: Workflow;
         userProfile: UserProfile;
         formulaire: Formulaire;
         serviceTask: ServiceTask;
       }